/* @kdd-custom — E1 la piste en cours (articles de blog).
   - Construit la tracklist depuis les h2 du corps (ids posés à la volée).
   - Fait avancer l'aiguille du sillon avec la lecture.
   PIÈGE HORIZON documenté : le défilement vit dans .page-wrapper, pas
   window — on écoute les deux. Tout organe animé n'apparaît que sous
   [data-kdd-lecture-actif] (posé ici) : sans JS, rien de cassé, rien de
   figé à zéro. */
(function () {
  function initLecture() {
    var racine = document.querySelector('[data-kdd-lecture]');
    if (!racine || document.body.hasAttribute('data-kdd-lecture-actif')) return;
    var corps = document.querySelector('.template-article .rte') ||
      document.querySelector('#MainContent .rte');
    if (!corps) return;

    /* Tracklist. */
    var pistes = racine.querySelector('.kdd-al__pistes');
    var h2s = Array.prototype.slice.call(corps.querySelectorAll('h2'));
    if (pistes && h2s.length > 1) {
      h2s.forEach(function (h2, i) {
        if (!h2.id) h2.id = 'piste-' + (i + 1);
        var a = document.createElement('a');
        a.href = '#' + h2.id;
        a.textContent = (i + 1 < 10 ? '0' : '') + (i + 1) + ' · ' + h2.textContent.trim();
        a.setAttribute('data-kdd-event', 'article_tracklist_' + (i + 1));
        pistes.appendChild(a);
      });
    }

    /* Aiguille de progression. */
    var joue = racine.querySelector('.kdd-al__joue');
    var aiguille = racine.querySelector('.kdd-al__aiguille');
    function avance() {
      var r = corps.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var total = r.height - vh;
      var p = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 1;
      var pct = (p * 100).toFixed(2) + '%';
      if (joue) joue.style.width = pct;
      if (aiguille) aiguille.style.left = 'calc(' + pct + ' - 1px)';
    }

    document.body.setAttribute('data-kdd-lecture-actif', '');
    avance();

    var wrapper = document.querySelector('.page-wrapper');
    if (wrapper) wrapper.addEventListener('scroll', avance, { passive: true });
    window.addEventListener('scroll', avance, { passive: true });
    window.addEventListener('resize', avance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLecture);
  } else {
    initLecture();
  }
  document.addEventListener('shopify:section:load', initLecture);
})();
